import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

// Import API test function
// import testApiUrl from './api/testApiUrl';

// Import components
import SignUpLogin from './components/SignUpLogin';
import Welcome from './components/Welcome';
import SetupPassword from './components/SetupPassword';
import PasswordAuth from './components/PasswordAuth';
import InvestmentType from './components/InvestmentType';
import OrganizationSetup from './components/OrganizationSetup';
import SubscriptionForm from './components/SubscriptionForm';
import EmailPasswordAuth from './components/EmailPasswordAuth';
import AuthGuard from './components/AuthGuard';
import LiveChatWidget from './components/LiveChatWidget';

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#6366f1', // Purple color similar to AngelList
    },
    secondary: {
      main: '#f3f4f6',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.2,
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.3,
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '12px 24px',
          fontSize: '1rem',
          fontWeight: 500,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

function App() {
  useEffect(() => {
    // Test API URL configuration on app load
    // testApiUrl();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#fafafa',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Router>
          <Routes>
            <Route 
              path="/" 
              element={
                <AuthGuard requireAuth={false}>
                  <EmailPasswordAuth />
                </AuthGuard>
              } 
            />
            <Route 
              path="/setup-password" 
              element={
                <AuthGuard requireAuth={false}>
                  <SetupPassword />
                </AuthGuard>
              } 
            />
            <Route 
              path="/investment-type" 
              element={
                <AuthGuard requireAuth={true}>
                  <InvestmentType />
                </AuthGuard>
              } 
            />
            <Route 
              path="/organization-setup" 
              element={
                <AuthGuard requireAuth={true}>
                  <OrganizationSetup />
                </AuthGuard>
              } 
            />
            <Route 
              path="/subscription" 
              element={
                <AuthGuard requireAuth={true}>
                  <SubscriptionForm />
                </AuthGuard>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <LiveChatWidget />
        </Router>
      </Box>
    </ThemeProvider>
  );
}

export default App;
